import { Injectable } from '@angular/core';
  import { BehaviorSubject, Observable } from 'rxjs';
import { ToastType } from '@ui-components/models';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
 
@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient) { }

  public CurrentMenu: BehaviorSubject<any> = new BehaviorSubject(null);
  public CurrentMenu$ = this.CurrentMenu.asObservable();
  public CurrentSite: BehaviorSubject<any> = new BehaviorSubject(null);
  public CurrentSite$ = this.CurrentSite.asObservable();

  private totalReportsSubject = new BehaviorSubject<any>(null);
  totalReports$: Observable<any> = this.totalReportsSubject.asObservable();



  public disconnect() {
    this.CurrentMenu = new BehaviorSubject<any>(null);
    this.CurrentMenu$ = this.CurrentMenu.asObservable();
    this.CurrentSite = new BehaviorSubject<any>(null);
    this.CurrentSite$ = this.CurrentSite.asObservable();
  }

  setCurrentMenu(menu) {
    this.CurrentMenu.next(menu);
  }

  setCurrentSite(site) {
    this.CurrentSite.next(site);
  }
  public openSnackBar(message: string,type:ToastType) {
    // this._snackBar.open(message, '', {
    //   duration: 2000,
    //   panelClass:[type]
    // });

    console.log("snak-bar");
    
  }
  getReportCount() {
    return this.http.get('/Reports/GetReportDetailsCount').pipe(
      tap((x: any) => x && this.totalReportsSubject.next(Number(x)))
    );
  }
}
